/**
 * router.ts — hash router เล็ก ๆ สำหรับ SPA (ไม่ใช้ framework)
 */
export interface Page {
  title: string;
  render(): string;
  mount?(root: HTMLElement): void;
}

export type Routes = Record<string, Page>;

export function createRouter(routes: Routes, outlet: HTMLElement, onChange?: (path: string) => void) {
  function current(): string {
    // hash อาจมี query ของตัวกรอง เช่น `#pnl?from=2025-04-01&to=...`
    const h = location.hash.replace(/^#/, '').split('?')[0] ?? '';
    return routes[h] ? h : Object.keys(routes)[0]!;
  }
  function render(): void {
    const path = current();
    lastPath = path;
    const page = routes[path]!;
    document.title = `${page.title} · RRP P&L`;
    outlet.innerHTML = page.render();
    page.mount?.(outlet);
    onChange?.(path);
  }
  let lastPath = '';
  window.addEventListener('hashchange', () => {
    // เปลี่ยนเฉพาะ query ของตัวกรอง (หน้าเดิม) ไม่ต้อง render ใหม่ทั้งหน้า
    if (current() === lastPath) return;
    render();
  });
  return { render, current };
}
